// extracted by mini-css-extract-plugin
export var actions = "_tc-4";
export var item = "_tc-1";
export var price = "_tc-3";
export var quantity = "_tc-2";
export var table = "_tc-0";